import {CompetitorResultsDetail, Race} from "@model";
import {Pipe, PipeTransform} from "@angular/core";
import {getCompetitorDistance} from "@utility";


@Pipe({
    name: 'competitorDistance',
    standalone: false
})
export class CompetitorDistancePipe implements PipeTransform {
    transform(competitorResultsDetail?: CompetitorResultsDetail, race?: Race): number | undefined {
       return getCompetitorDistance(competitorResultsDetail, race);
    }

}


